import PropTypes from "prop-types";
import { Modal } from "@/config/antd";
import { CloseOutlined, SearchOutlined } from "@/config/antd";
import Input from "@/components/common/inputs/Input";

const LocationModal = ({ isVisible, onClose }) => {
  const locations = [
    {
      state: "Ekiti State",
      localGovts: "16 Local Governments",
    },
    {
      state: "Lagos State",
      localGovts: "16 Local Governments",
    },
    {
      state: "Zamfara State",
      localGovts: "16 Local Governments",
    },
    {
      state: "Ogun State",
      localGovts: "16 Local Governments",
    },
  ];

  return (
    <Modal
      open={isVisible}
      onCancel={onClose}
      footer={null}
      centered
      width={600}
      closeIcon={null}
      styles={{
        body: { padding: 0 },
        content: {
          padding: 0,
          borderRadius: "16px",
          overflow: "hidden",
        },
        mask: { backgroundColor: "rgba(0, 0, 0, 0.75)" },
      }}>
      <div className="flex flex-col bg-white">
        {/* Header */}
        <div className="p-4 px-6 flex justify-between items-center border-b">
          <h2 className="text-bold-x text-primary">Change Location</h2>
          <CloseOutlined
            onClick={onClose}
            className="cursor-pointer hover:bg-gray-100 p-2 rounded-full"
          />
        </div>

        {/* Search Input */}
        <div className="p-6">
          <Input
            placeholder="Search location"
            icon={<SearchOutlined />}
            className="w-full"
            iconPosition="left"
          />
        </div>

        {/* Content Area - Location List */}
        <div className="px-6 pb-6">
          <div className="divide-y">
            {locations.map((location, index) => (
              <div key={index} className="py-4 cursor-pointer hover:bg-gray-50">
                <h3 className="text-regular font-bold text-darkGrey mb-1">
                  {location.state}
                </h3>
                <p className="text-small-xs text-lighterGrey">
                  {location.localGovts}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
};

LocationModal.propTypes = {
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
};

export default LocationModal;
